import { render, staticRenderFns } from "./CompCarouselArrows.vue?vue&type=template&id=2d67a0fe&scoped=true"
import script from "./CompCarouselArrows.vue?vue&type=script&setup=true&lang=js"
export * from "./CompCarouselArrows.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompCarouselArrows.vue?vue&type=style&index=0&id=2d67a0fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d67a0fe",
  null
  
)

export default component.exports